import { render, staticRenderFns } from "./relation-checkbox.vue?vue&type=template&id=0ead7c8a"
import script from "./relation-checkbox.vue?vue&type=script&lang=ts"
export * from "./relation-checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports